export default __webpack_public_path__ + "static/media/student.3f2d9389.png";